import { render, staticRenderFns } from "./Lgx371305280681541632.vue?vue&type=template&id=27217d3c&"
import script from "./Lgx371305280681541632.vue?vue&type=script&lang=js&"
export * from "./Lgx371305280681541632.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports